/* 模块组件 ChenYN 说明 用户协议 版本 1.0 传参 checked Boolean : 是否选中 changeCheck Function :
勾选事件回调 依赖 /style/2019/h5/css/common.css vue.js 案例
<CheckAgreement></CheckAgreement>
*/

<template>
    <div class="check_agreement">
        <div class="check_wrap" @click="checkedClick">
            <img
                v-if="checked"
                src="@/assets/images/common/icon_check.png"
                class="check_box_img"
            />
            <img v-else src="@/assets/images/common/icon_checkbox.png" class="check_box_img" />
        </div>
        <div>
            我已阅读并同意<span class="link_wrap" @click="reqAgreement(1)"
                >&nbsp;用户协议&nbsp;</span
            >及<span class="link_wrap" @click="reqAgreement(2)">&nbsp;隐私政策</span
            ><span v-if="phoneTips">，未注册的手机号将自动注册</span>
        </div>
    </div>

    <Popup v-model:show="showPop" teleport="#app" class="agreement_pop">
        <div class="agreement_dialog">
            <div class="title">{{ popData.title }}</div>
            <pre class="dialog_content cancel_scroll_bar">{{ popData.content }}</pre>
        </div>
    </Popup>
</template>

<script lang="js">
import { defineComponent, reactive, toRefs } from 'vue';
import { Popup } from "vant"
import Util from '@/assets/js/lib/util';
import agreementData from '@/assets/js/agreement-data.js';

export default defineComponent({
    name: 'CheckAgreement',
    components: {
        Popup
    },
    props: {
        phoneTips: {
            type: Boolean,
            default: false
        },
        checked: {
            type: Boolean
        },
        changeCheck: {
            type: Function
        }
    },
    setup(props) {
        const state = reactive({
        showPop: false,
        util: new Util(),
        popData: {
            title: '',
            content: ''
        },
        });

        const checkedClick = () => {
        props.changeCheck()
        }

        const reqAgreement = async (type = 1) => {
            const txt={
                '1':{
                    title: '9377平台用户协议条款',
                    content: agreementData.useragreement
                },
                '2':{
                    title: '隐私政策',
                    content: agreementData.privacypolicy
                }
            };

            state.popData = txt[type];
            state.showPop = true;

        };

        return{
        ...toRefs(state),
        checkedClick,
        reqAgreement
        }
    },
});
</script>
<style lang="less" scoped>
@charset "utf-8";
@charset "utf-8";
@import "./CheckAgreement.less";
</style>
